import React from 'react'
import './LanHero.css'
import img from './../../Assets/arrow.png'
import img2 from './../../Assets/socialhero.png'


function LanHero() {

    const observer = new IntersectionObserver((enteries) => {
        enteries.forEach((entry) => {
          console.log(entry);
          if(entry.isIntersecting){
            entry.target.classList.add('show');
          }
        })
      })
    
      setTimeout(() => {
      const hiddenElements = document.querySelectorAll('.hidden');
      hiddenElements.forEach((el) => observer.observe(el));
      });

    return (
        <div id='lanhero' className='hidden' >
            <h1>Secure your data.</h1>
            <h2>Find threats!</h2>
            <p>Elevate your cybersecurity with our comprehensive solutions.</p>
            <p> Safeguard your data and fortify your digital space for a resilient and safe business environment</p>
            <div className='lanhero_btn_container'>
                <button>Get Started 🔥</button>
                <img src={img}/>
            </div>
            <div className='lanhero_social_container'>
                <img src={img2}/>
            </div>
        </div>
    )
}

export default LanHero
